import { render } from "./gatheround.vue?vue&type=template&id=64406f36"
import script from "./gatheround.vue?vue&type=script&lang=js"
export * from "./gatheround.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__